import { CloseCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Drawer,
  Form,
  Row,
  Select,
  Tag
} from "antd";
import CustomDropDown from "../customDropDown/customDropDown";
import CustomDatePicker from "../datePicker/datepicker";
import CustomDateRangePicker from "../datePicker/rangePicker";
import InputComponent from "../input/input"
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Operators } from "./operators";
import filterStyles from "./seacrFilterModule.module.scss";
import CascadeDropDown from "../customDropDown/cascadeDropDown";
import CustomIcon from "../icons/CustomIcon";
import React from "react";
import debounce from "lodash/debounce";

const { Option } = Select;

interface Props {
  searchForm: any,
  getSearchQuery: any;
  applyFilterLabel?: string;
  hideClearFilter?: boolean;
  moduleName?: string;
  showAdvanced?: boolean;
  openMode?: boolean;
  preFillFilters?:any[]
}

const SearchFilterModule: React.FC<Props> = ({
  searchForm,
  getSearchQuery,
  applyFilterLabel = "Apply Filter",
  hideClearFilter = false,
  moduleName = "",
  showAdvanced = true,
  openMode = false,
  preFillFilters = []
}) => {

  const tempFilters = preFillFilters.map((item) => item.field);

  const [filters, setFilters] = useState<string[]>(tempFilters);

  const [searchFilter, setSearchFilter] = useState<any[]>(preFillFilters);

  const [quickSearchFilter, setQuickSearchFilter] = useState<any[]>([]);

  const [updateFlag, setUpdateFlag] = useState<boolean>(false);

  useEffect(() => {

    if (updateFlag) {
      applyFilters();
      setUpdateFlag(false);
    }
  }, [updateFlag]);

  const [open, setOpen] = useState<boolean>(false);

  const [selectAll, setSelectAll] = useState(false); // State to track "Select All" checkbox
  const { control } = useForm<any>({});

  useEffect(() => {

    //If there are prefill filters -  default filters will be ignored
    if (searchForm && searchForm.length > 0 && preFillFilters.length === 0) {
      selectDefaultAdvancedFilters();
    }

  }, [searchForm]);


  const removeSearchFilter = (field: string, callApply: boolean = false) => {


    const index = searchFilter.findIndex((item) => item.field === field);

    if (index !== -1) {

      const newSearchFilter = [...searchFilter];
      newSearchFilter.splice(index, 1);


      setSearchFilter(newSearchFilter);

      if (filters) {
        const newFilters = [...filters];
        newFilters.splice(index, 1);
        setFilters(newFilters);
      }



      if (callApply) {
        setUpdateFlag(true);
      }

    }

  };

  // This method is called to render the selected filters
  const renderAdvancedFilters = (fields: any): any => {

    if (searchForm && searchForm?.length > 0) {

      return (
        <div className="filter-selection">
          <div className="relative">

            <Form onFinish={() => applyFilters()}>

              {fields?.map((selectedField: any, fieldIndex: number) => {

                return searchForm?.map((filter: any) =>

                  filter?.field === selectedField ? (
                    <>
                      <Row key={fieldIndex} className="search-area">
                        {/* filter label   */}
                        <Col lg={{ span: 4 }} className="search-label text-left pt-2 mt-2 mx-2 px-md-3">
                          <label className="pt-4">
                            {filter?.displayName}
                            <span
                              className={filterStyles.removeFilterText + " display-only-mobile mx-2"}
                              onClick={() => {
                                removeSearchFilter(filter.field);
                              }}
                            >
                              <CloseCircleOutlined rev={undefined}></CloseCircleOutlined>
                            </span>
                          </label>

                        </Col>

                        {/* filter operator */}
                        {<Col lg={{ span: 6 }} className="search-operator text-left mt-2 mx-2 px-md-3">

                          {filter?.fieldType !== "checkBox" ? (
                            <div className="w-100">
                              <Select
                                className="w-100"
                                listHeight={200}
                                onChange={(e: any) =>
                                  handleOnChangeOperator(e, filter?.field, fieldIndex)
                                }
                                placeholder="Select Operator"
                                defaultValue={() => {

                                  if (filter.rules && filter.rules[0].isMulti && filter?.fieldType === "dropDown") {
                                    return "in";
                                  }

                                  if (filter.rules && filter?.fieldType === "calendarWithRange") {
                                    return "btw";
                                  }

                                  const operatorCode = searchFilter.find((item) => item.field === filter.field).operator ?? getDefaultOperatorCode(filter.field);

                                  return operatorCode;

                                }}

                                disabled={filter?.fieldType === "calendarWithRange"} //Calendar with range will have between as default filter
                              >


                                {Operators?.map((operator: any, index: number) => {

                                  //Do not show includes operator unless it is multi select
                                  if (filter.rules && !filter.rules[0].isMulti && operator.code === "in") {
                                    return <></>;
                                  }

                                  //If there are no rules - apply all operators
                                  if (!filter.hasOwnProperty("rules")) {
                                    return (<Option key={index} value={operator?.code}>
                                      {operator?.name}
                                    </Option>)
                                  }


                                  //If allow values doesn't exist for a field type display all operators
                                  if (filter.hasOwnProperty("rules") && !(filter?.rules[0].allowValues)) {
                                    return (
                                      <Option selected key={index} value={operator?.code}>
                                        {operator?.name}
                                      </Option>
                                    )
                                  } else if (operator.validFor.includes("*")) {
                                    //Checking if Operator is valid for all types
                                    return (
                                      <Option key={index} value={operator?.code}>
                                        {operator?.name}
                                      </Option>
                                    )
                                  } else if (operator.validFor.includes(filter?.rules[0].allowValues)) {
                                    //Checking if Operator is valid for field type
                                    return (
                                      <Option key={index} value={operator?.code}>
                                        {operator?.name}
                                      </Option>
                                    )
                                  }

                                })}

                              </Select>
                            </div>
                          ) : (
                            <></>
                          )}
                        </Col>}


                        {/* filter input */}
                        {(searchFilter[fieldIndex].operator !== "blk" && searchFilter[fieldIndex].operator !== "nbl") && <Col lg={{ span: 10 }} md={{ span: 16 }} className="search-input mx-2 mt-2">

                          {(() => {
                            switch (filter?.fieldType) {
                              case 'textBox':
                                return (<InputComponent
                                  placeholder={filter?.placeholder ?? filter?.displayName}
                                  value={getAdvFilterValue(filter?.field)}
                                  rules={filter?.rules && filter?.rules[0]}
                                  control={control}
                                  onChange={(e: any) =>
                                    handleOnChange(e.target?.value, filter?.field, fieldIndex)
                                  }
                                />)

                              case 'dropDown':
                                return (<>
                                  <CustomDropDown
                                    title={filter?.field}
                                    control={control}
                                    name={filter?.field}
                                    value={getAdvFilterValue(filter?.field) || []}
                                    onChange={(e: any) => {
                                      handleOnChange(e, filter?.field, fieldIndex);
                                    }}
                                    api={filter.api}
                                    rules={filter?.rules[0]}
                                    dropdownCode={filter?.dropdownCode}
                                    dropdownValue={filter?.dropdownValue}
                                    placeholder={filter?.placeholder}
                                    showOnlyValue={filter.rules[0].showOnlyValue}
                                    className="w-100 text-left"
                                    maxTagCount={2}
                                    staticDropDownValues={filter.staticDropDownValues ?? []}
                                  />

                                </>)
                              case 'cascadeDropDown':
                                return (<>
                                  <CascadeDropDown
                                    name={filter?.field}
                                    title={filter?.field}
                                    control={control}
                                    data={getAdvFilterValue(filter?.field)}
                                    setValue={() => {

                                    }}
                                    onChange={(e: any) => {

                                      handleOnChange(e, filter?.field, fieldIndex, false, undefined, true);
                                      // setTimeout(() => { handleCascadeOnChange(e, filter?.field, fieldIndex) }, 100);
                                    }}
                                    api={filter.api}
                                    rules={filter?.rules[0]}
                                    dropdownCode={filter?.dropdownCode}
                                    dropdownValue={filter?.dropdownValue}
                                    placeholder={filter?.displayName}
                                    isCascade={
                                      filter.valuesDependOnField !== undefined &&
                                      filter.valuesDependOnField !== null &&
                                      filter.valuesDependOnField !== ""
                                    }
                                    showOnlyValue={filter?.rules[0]?.showOnlyValue}
                                  />

                                </>)
                              case 'calendar':
                                return (<>
                                  <Form.Item
                                    className="px-0"
                                    name={filter?.field}
                                    key={filter?.displayName}
                                    rules={[
                                      {
                                        required: true, //hard-coded true here as - In filters every field is mandatory
                                        message: "Please select the value.",
                                      },
                                    ]}
                                  >
                                    <CustomDatePicker
                                      title={filter?.displayName}
                                      disabled={false}
                                      showTime={filter?.rules[0].showTime}
                                      rules={filter?.rules[0]}
                                      placeholder={filter?.placeholder}
                                      control={control}
                                      setValue={(name: any, data: any) => { }}
                                      data={getAdvFilterValue(filter?.field)}
                                      name={filter.field}
                                      id={filter.fieldIndex}
                                      onChange={(e: any) => {
                                        handleOnChange(
                                          e,
                                          filter?.field,
                                          fieldIndex
                                        );
                                      }} />
                                  </Form.Item>

                                </>)
                              case 'calendarWithRange':
                                return (<>
                                  <Form.Item
                                    className="px-0"
                                    name={filter?.field}
                                    key={filter?.displayName}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please select the value.",
                                      },
                                    ]}
                                  >
                                    <CustomDateRangePicker
                                      title={filter?.displayName}
                                      // data={[]}
                                      disabled={false}
                                      showTime={filter?.rules[0].showTime}
                                      rules={filter?.rules[0]}
                                      placeholder={filter?.placeholder}
                                      control={control}
                                      data={getAdvFilterValue(filter?.field)}
                                      name={filter.field}
                                      id={filter.fieldIndex}
                                      onChange={(e: any[2]) => {

                                        handleOnChange(
                                          [e[0], e[1]],
                                          filter?.field,
                                          fieldIndex
                                        );

                                      }} />
                                  </Form.Item>

                                </>)
                              case 'checkBox':
                                return (<Checkbox
                                  onChange={(e: any) => {
                                    handleOnChange(
                                      e.target?.checked.toString(),
                                      filter?.field,
                                      fieldIndex
                                    );
                                  }}
                                >
                                </Checkbox>)
                              default:
                                return <></>
                            }
                          })()}


                        </Col>}

                        {(searchFilter[fieldIndex].operator !== "blk" && searchFilter[fieldIndex].operator !== "nbl") && <Col lg={{ span: 1 }} md={{ span: 8 }} className="text-left d-flex align-items-center">
                          <span
                            className={filterStyles.removeFilterText + " " + filterStyles.hiddenOnMobile}
                            onClick={() => {
                              removeSearchFilter(searchFilter[fieldIndex].field);
                            }}>
                            <CloseCircleOutlined rev={undefined}></CloseCircleOutlined>
                          </span>
                        </Col>}


                      </Row>
                    </>
                  ) : null
                );
              })}

              {/* Search Filter action buttons */}
              {filters?.length! > 0 && (
                <div
                  className="mt-3 text-center ">



                  {hideClearFilter ? <></> : (

                    <Button
                      title={"Clear Filter"}
                      className="mx-2"
                      
                      style={{ justifyContent: "center" }}
                      onClick={() => {
                        onClearFilter();
                      }}
                    >
                      Clear Filter
                    </Button>

                  )}

                  <Button
                    style={{ justifyContent: "center" }}
                    title={applyFilterLabel}
                    className="mx-2"
                    type="primary"
                    htmlType="submit"
                  >
                    {applyFilterLabel}
                  </Button>

                </div>
              )}

            </Form>
          </div>
        </div>


      );
    }
  };

  const getQuickFilterValue = (field: string) => {
    const filter = quickSearchFilter.find((item) => item.field === field);
    return filter?.value ?? "";
  }

  const getAdvFilterValue = (field: string) => {
    const filter = searchFilter.find((item) => item.field === field);
    return filter?.value ?? "";
  }


  // This method is malled to render the selected filters
  const renderQuickFilters = (): any => {

    if (!(searchForm && searchForm.length > 0)) {
      return <></>;
    }

    let fields: string[] = [];
    searchForm.forEach((filter: any) => {
      if (filter.hasOwnProperty("quickSearchFilter") && filter.quickSearchFilter) {
        fields.push(filter.field);
      }
    });

    if (searchForm && searchForm?.length > 0) {
      return (
        <Form onFinish={() => applyFilters(true)}>

          <Row>
            {fields?.map((currentField: any, fieldIndex: number) => {

              return searchForm?.map((filter: any) =>

                filter?.field === currentField ? (
                  <>

                    <span className={filterStyles.quickFilterInput + " mr-2 my-md-0"}>
                      {/* filter input */}

                      {(() => {
                        switch (filter?.fieldType) {
                          case 'textBox':
                            return (<InputComponent
                              suffix={<CustomIcon className="mx-1 site-form-item-icon text-primary opacity-5" name="searchLens"></CustomIcon>}
                              placeholder={filter?.displayName}
                              value={getQuickFilterValue(filter?.field)}
                              autoFocus={getQuickFilterValue(filter?.field) ? true : false}
                              rules={filter?.rules && filter?.rules[0]}
                              control={control}
                              className={filterStyles.inputs}
                              onChange={debounce((e) => {
                                handleOnChange(e.target?.value, filter?.field, fieldIndex, true);
                              }, 500)
                              }

                            // onChange={useCallback(
                            //   debounce((e) => {
                            //     // console.log("Input value:", e.target.value);
                            //     handleOnChange(e.target?.value, filter?.field, fieldIndex, true);
                            //     // You can handle the API call or any other action here
                            //   }, 1000), // 500ms debounce delay
                            //   []
                            // )}
                            />)

                          case 'dropDown':
                            return (<>
                              <CustomDropDown
                                title={filter?.field}
                                control={control}
                                name={filter?.field}
                                value={getQuickFilterValue(filter?.field)}
                                onChange={(e: any) => {
                                  handleOnChange(e, filter?.field, fieldIndex, true, filter?.operator);
                                }}
                                api={filter.api}
                                rules={filter?.rules[0]}
                                dropdownCode={filter?.dropdownCode}
                                dropdownValue={filter?.dropdownValue}
                                placeholder={filter?.displayName}
                                showOnlyValue={filter.rules[0].showOnlyValue}
                                maxTagCount={1}
                                staticDropDownValues={filter.staticDropDownValues ?? []}
                              />

                            </>)
                          case 'cascadeDropDown':
                            return (<>
                              <CascadeDropDown
                                name={filter?.field}
                                title={filter?.field}
                                control={control}
                                data={getQuickFilterValue(filter?.field)}
                                setValue={(name: any, data: any) => {
                                  // DND - will result in cascade value not getting stored - TBD
                                }}
                                onChange={(e: any) => {
                                  handleOnChange(e, filter?.field, fieldIndex, true, undefined, true);
                                }}
                                api={filter.api}
                                rules={filter?.rules[0]}
                                dropdownCode={filter?.dropdownCode}
                                dropdownValue={filter?.dropdownValue}
                                placeholder={filter?.displayName}
                                isCascade={
                                  filter.valuesDependOnField !== undefined &&
                                  filter.valuesDependOnField !== null &&
                                  filter.valuesDependOnField !== ""
                                }
                                showOnlyValue={filter?.rules[0]?.showOnlyValue}
                              />

                            </>)
                          case 'calendar':
                            return (<>
                              <Col span={24}>
                                <Form.Item
                                  name={filter?.field}
                                  key={filter?.displayName}
                                  rules={[
                                    {
                                      required: filter.rules[0].mandatory,
                                      message: "Please select the value.",
                                    },
                                  ]}
                                >
                                  <CustomDatePicker
                                    title={filter?.displayName}
                                    disabled={false}
                                    showTime={filter?.rules[0].showTime}
                                    rules={filter?.rules[0]}
                                    placeholder={filter?.placeholder}
                                    control={control}
                                    data={getQuickFilterValue(filter?.field)}
                                    setValue={(name: any, data: any) => {
                                      
                                    }}
                                    name={filter.field}
                                    id={filter.fieldIndex}
                                    onChange={(e: any) => {
                                      handleOnChange(
                                        e,
                                        filter?.field,
                                        fieldIndex,
                                        true
                                      );
                                    }} />
                                </Form.Item>
                              </Col>
                            </>)
                          case 'checkBox':
                            return (<Checkbox
                              onChange={(e: any) => {
                                handleOnChange(
                                  e.target?.checked.toString(),
                                  filter?.field,
                                  fieldIndex,
                                  true
                                );
                              }}
                            >
                            </Checkbox>)
                          default:
                            return <></>
                        }
                      })()}
                    </span>
                  </>
                ) : null
              );

            })}


            {fields.length > 0 && <span className="text-primary pointer d-inline mt-2 ml-1" onClick={() => clearQuickSearchFilters()}> Clear </span>}

          </Row>
        </Form>
      );
    }
  };

  // Util methods

  const handleSelectAllOptionClick = () => {

    if (selectAll) {
      setFilters([]);
      // setSelectedFilter([]);
      setSelectAll(false);
    } else {
      const allFilterFields = searchForm.map((filter: any) => filter.field);
      setFilters(allFilterFields);
      // setSelectedFilter(allFilterFields)
      setSelectAll(true);
      onFilterSelect(allFilterFields);
    }
  }



  const getDefaultOperatorCode = (field: string): string => {

    const currentFilter = searchForm.find((item: any) => item.field === field);

    let defaultOperatorCode: string = Operators.find((item) => {
      return ((item?.defaultSelected && item.validFor.includes(currentFilter?.rules[0].allowValues))) ? true : false
    })?.code as string;


    //Manipulating the selector according to input type
    if (currentFilter.rules && currentFilter.rules[0].isMulti && (currentFilter.fieldType === "dropDown" || currentFilter.fieldType === "cascadeDropDown")) {
      defaultOperatorCode = 'in';
    } else if (currentFilter.fieldType === "calendarWithRange") {
      defaultOperatorCode = 'btw';
    } else if (currentFilter.rules[0].allowValues === "onlyNumeric" || currentFilter.rules[0].allowValues === "onlyDigital") {
      defaultOperatorCode = 'eq';
    }


    if (defaultOperatorCode && defaultOperatorCode.length > 0) {
      return defaultOperatorCode;
    } else {
      return "lk";
    }

  }

  /* onFilterSelect Mehtod is called on selecting search filter - Only applicable for Advvanced filters
@param {filter} is the array of filters
*/
  const onFilterSelect = (selectedFilters: any[]) => {

    let searchArray: any[] = [];

    selectedFilters.forEach((elm: string, index: number) => {

      let searchFilterExists = searchFilter.find(item => item.field === elm) || false;

      if (!searchFilterExists) {
        searchArray.push({ field: elm, operator: getDefaultOperatorCode(elm), value: null, hideInputValue: false });
      } else {
        searchArray.push({ field: elm, operator: searchFilterExists.operator || getDefaultOperatorCode(elm), value: searchFilterExists.value, hideInputValue: searchFilterExists.hideInputValue });
      }

    });

    setSearchFilter(searchArray);

  }


  const onClearFilter = () => {

    // setSelectedFilter([]);
    setFilters([]);
    setSearchFilter([]);
    getSearchQuery(null, null, 'quick');

  };

  //This method keeps selected search filters and only removes their value - used for quick filters
  const clearQuickSearchFilters = () => {

    let updatedSearchFilter: any[] = [];

    setQuickSearchFilter(updatedSearchFilter);

    updatedSearchFilter = [];


    setSearchFilter(updatedSearchFilter);

    setFilters([]); // Clearing quick search filters will clear advanced filters as well
    // applyFilters();

    getSearchQuery("&search=", []);

  };


  const handleCascadeOnChange = (value: any, field: string, index: number, quickSearch: boolean = false) => {

    const currentApplicableFilters = quickSearch ? quickSearchFilter : searchFilter;

    //Start of handling cascade
    let indexOfFieldToRefresh = searchForm.findIndex(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField === field
    );

    // fetch field from editform as this has the api urls for the cascade fields
    let fieldToBeEdited = searchForm.find(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField == field
    );


    if (
      indexOfFieldToRefresh === -1 ||
      fieldToBeEdited === null ||
      fieldToBeEdited === undefined
    ) {

      return currentApplicableFilters;
    }

    // let fieldToRefresh = searchForm[indexOfFieldToRefresh];

    // modify api query params based on selection
    let api = fieldToBeEdited.api;
    api = api.split("&search=")[0];

    let apiWithQueryParams = `${api}&search=${field}:in${value}`;
    fieldToBeEdited.api = apiWithQueryParams;

    searchForm[indexOfFieldToRefresh] = fieldToBeEdited;




    const currentFilter = (quickSearch ? quickSearchFilter : searchFilter).find((item) => item.field === fieldToBeEdited.field);

    const updatedItems = currentApplicableFilters.map(item =>
      item.field === fieldToBeEdited.field ? { field: fieldToBeEdited.field, operator: currentFilter?.operator, value: null, hideInputValue: currentFilter?.hideInputValue ?? false } : item
    );


    return updatedItems;

  }


  useEffect(() => {
    if (quickSearchFilter && quickSearchFilter.length > 0) {
      applyFilters(true);
    }
  }, [quickSearchFilter]);

  const handleOnChange = (val: any, field: string, index: number, quickSearch: boolean = false, operator?: string, isCascaded: boolean = false) => {


    if (typeof val === 'string') {
      val = val.trim();
    }


    const currentApplicableFilters = quickSearch ? quickSearchFilter : searchFilter;
    const currentFilter = currentApplicableFilters.find((item) => item.field === field);

    let updatedItems: any = currentApplicableFilters;

    if (isCascaded) {
      updatedItems = handleCascadeOnChange(val, field, index, quickSearch);
    }

    if (currentFilter) {

      updatedItems = updatedItems.map((item: any) => {

        if (item.field === currentFilter.field) {
          return { field: field, operator: currentFilter?.operator ?? operator, value: val, hideInputValue: currentFilter?.hideInputValue ?? false };
        }

        return item;

      });

    } else {
      updatedItems = [...currentApplicableFilters, { field: field, operator: getDefaultOperatorCode(field), value: val, hideInputValue: currentFilter?.hideInputValue ?? false }];
    }


    if (quickSearch) {
      setQuickSearchFilter(updatedItems);
    } else {
      setSearchFilter(updatedItems);
    }


    //For string input do not call API when input is empty or greater than 3 chars
    if (typeof val === "string" && (val.length > 0 && val.length < 3)) {
      return;
    }


  };

  const handleOnChangeOperator = (value: any, field: string, index: number) => {

    const selectedOperator = Operators.find(operator => operator?.code === value);
    if (selectedOperator?.hideInputValue) {
      searchFilter[index] = { field: field, operator: value, value: null, hideInputValue: true };
    } else {
      searchFilter[index] = { field: field, operator: value, value: searchFilter[index].value, hideInputValue: false };
    }
    setSearchFilter(JSON.parse(JSON.stringify(searchFilter)));

  };


  const selectDefaultAdvancedFilters = () => {

    let defaultFilters: string[] = [];
    searchForm.forEach((filter: any) => {
      if (filter.hasOwnProperty("selectedByDefault") && filter.selectedByDefault) {
        defaultFilters.push(filter.field);
      }
    });

    setFilters([]);
    setFilters(defaultFilters);
    onFilterSelect(defaultFilters);

  }

  // This method is called when apply filter is clicked
  const applyFilters = (isQuick: boolean = false) => {



    let queryString = "&search=";

    // TODO: this has to be refactored later, just for testing hardcoded condition here.
    const inverseHierarchyCheckFilter = searchFilter.find((filterObj: any) => filterObj.field === 'inverseHierarchyCheck');

    if (inverseHierarchyCheckFilter) {
      queryString = "&inverseHierarchyCheck=" + inverseHierarchyCheckFilter.value + "&search=";
    }

    let currentApplicableFilters = searchFilter;



    if (isQuick) {
      currentApplicableFilters = quickSearchFilter;
    } else {

      //if applyFilters is called without quick search flag 
      //Advance filters are applied hence clear quick search filters
      // let updatedSearchFilter: any[] = [];

      // quickSearchFilter.forEach((filter) => {

      //   filter.value = null;
      //   updatedSearchFilter.push(filter);

      // });

      // setQuickSearchFilter(updatedSearchFilter);
      setQuickSearchFilter([]);

    }



    if (currentApplicableFilters.length > 0) {

      currentApplicableFilters.filter((filterObj: any) => filterObj.field !== 'inverseHierarchyCheck').forEach((filterObj: any) => {

        if (filterObj.value && filterObj.value.length > 0) {

          if (filterObj.operator === "btw") {

            queryString = queryString + filterObj.field + ":" + "ge" + filterObj.value[0] + ";"
            queryString = queryString + filterObj.field + ":" + "le" + filterObj.value[1] + ";"

          } else {
            queryString = queryString + filterObj.field + ":" + (filterObj.operator ?? getDefaultOperatorCode(filterObj.field)) + filterObj.value + ";"
          }
        } else if (filterObj.operator === "blk" || filterObj.operator === "nbl") {
          queryString = queryString + filterObj.field + ":" + filterObj.operator + ";";
        }

      })
    }


    setOpen(false);

    if (isQuick) {

      getSearchQuery(queryString, quickSearchFilter);
    } else {
      getSearchQuery(queryString, searchFilter);
    }

  };

  if (openMode) {
    return <>{renderAdvancedFilters(filters)}</>
  }

  return (
    <>
      <div className="justify-content-between block-on-mobile">
        <div>
          {renderQuickFilters()}
        </div>


        <div>

          <div className="justify-content-between mb-2 block-on-mobile">
            <div className="align-items-center">
              <p> {searchFilter?.map((item, index) => {

                if (item.value && item.value.length > 0) {
                  const temp = searchForm.find((x: any) => x.field === item.field);

                  return <Tag bordered={true} color="geekblue" className="d-inline mr-1 p-1 text-sm" closeIcon={<CloseCircleOutlined className="mx-1 pt-2 text-lg" size={14} />} closable onClose={() => removeSearchFilter(item.field, true)}>

                    {temp.fieldType === 'textBox' ? <>{temp.displayName} : {item.value} </> : <>{temp.displayName}</>}
                  </Tag>
                }
              })}
              </p>
            </div>

            <div className="text-center">
              {showAdvanced && <Button  className="mx-1 mb-1" onClick={() => setOpen(true)}><CustomIcon name="filter"></CustomIcon></Button>}
              <Button
                className="mx-1 mb-1"
                
                onClick={() => clearQuickSearchFilters()}
                title="Refresh">
                <CustomIcon name={"refresh"}> </CustomIcon>
              </Button>
            </div>

          </div>

        </div>

      </div>
      <Drawer
        className="search-filter-model"
        placement="right"
        width={window.innerWidth > 900 ? 800 : window.innerWidth - 100}
        onClose={() => setOpen(false)}
        title={moduleName ?? "Search Filters"}
        open={open}>

        <div className="mb-1">
          <div className="px-0 text-right notranslate">
            {/* Filter select dropdown */}
            <>
              <Select
                mode="multiple"
                listHeight={200}
                value={filters}
                maxTagCount={0}
                maxTagPlaceholder={filters?.length + " selected"}
                onChange={(filters) => {
                  if (filters.includes("all")) {
                    handleSelectAllOptionClick();
                  } else {
                    setFilters([]);
                    // setSelectedFilter([]);
                    // setSelectedFilter(filters);
                    setFilters(filters);
                    onFilterSelect(filters);
                  }
                }}
                placeholder={"Select filter"}
                className="select mb-2 mx-2"
                style={{ width: "200px" }}
              >
                {searchForm &&
                  searchForm?.length > 0 && (
                    <>
                      <Option key="all" value="all">
                        {selectAll ? "Unselect All" : "Select All"}
                      </Option>
                      {searchForm.map((filter: any, index: number) => (
                        <Option key={index} value={filter.field}>
                          <Checkbox className="mr-2" checked={filters?.includes(filter.field)} onChange={(ev) => { ev.stopPropagation(); ev.preventDefault(); }}></Checkbox>
                          {filter.displayName}
                        </Option>
                      ))}
                    </>
                  )}
              </Select>
            </>

          </div>

          <Row>

            <Col span={24}>
              {
                <>

                  {(filters && filters.length > 0) && <div className="search-render-block"  >
                    <div>
                      {renderAdvancedFilters(filters)}
                    </div>
                  </div>}
                  {((filters && filters.length <= 0)) &&

                    <div className={filterStyles.searchWatermark}>
                      <CustomIcon className="text-secondary opacity-5" height="128px" width="128px" name="searchLens"></CustomIcon>
                    </div>
                  }
                </>
              }
            </Col>
          </Row>
        </div>
      </Drawer>
    </>

  )
}


export default React.memo(SearchFilterModule);